import React from 'react'
import './about.css';
import { HiArrowNarrowRight } from 'react-icons/hi';

const About = () => {
  return (
    <div className='about section_padding'>
      <div className='about-container'>
        <h2>Have a project in mind? Schedule a free consultation today.</h2>
        <div className='product-button'>
        <div className='product-button-content'>
          <a href='#product'>Contact Sales</a>
          <HiArrowNarrowRight className='arrow-icon' />

        </div>
      </div>
      </div>
    </div>
  )
}

export default About